import React, { useState, useEffect } from 'react';
import { Col } from 'react-bootstrap';
import { Input } from 'components/partials/Fields/FormikInput';
import { Section } from 'components/FormikForm/Section';
import { Select } from 'components/partials/Fields/FormikSelect';
import usePasswordValidation from 'hooks/usePasswordValidation';
import DoubleColumn from 'components/FormikForm/Section/DoubleColumn';
import Stacked from 'components/FormikForm/Section/Stacked';
import 'styles/components/PasswordValidation.scss';

const Password = ({ checkPassword = () => {}, ...props }) => {
    const [password, setPassword] = useState({
        password: '',
        password_confirm: '',
    });
    const [newType, setNewType] = useState('password');
    const [confirmType, setConfirmType] = useState('password');
    const [showPass, setShowPass] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const [
        isValidLength,
        hasNumber,
        hasUpperCase,
        hasLowerCase,
        doesMatch,
        sixMonths,
        lastFive,
        loading,
    ] = usePasswordValidation({
        password: password.password,
        password_confirm: password.password_confirm,
        userId: props.userId,
        extra_rules: props.extraRules,
    });

    const setNew = (event) => {
        setPassword({ ...password, password: event.value });
    };

    const setConfirm = (event) => {
        setPassword({ ...password, password_confirm: event.value });
    };

    const showHideNew = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowPass(!showPass);
        setNewType(showPass ? 'password' : 'text');
    };

    const showHideConfirm = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowConfirm(!showConfirm);
        setConfirmType(showConfirm ? 'password' : 'text');
    };

    const rules = [
        {
            label: 'Six character minimum',
            check: isValidLength,
        },
        {
            label: 'At least one upper case letter',
            check: hasUpperCase,
        },
        {
            label: 'At least one lower case letter',
            check: hasLowerCase,
        },
        {
            label: 'At least one number',
            check: hasNumber,
        },
        {
            label: 'Confirm password matches',
            check: doesMatch,
        },
    ];

    const additionalRules = [
        {
            label: 'Passwords from the past 6 months',
            check: sixMonths,
        },
        {
            label: 'The previous 5 passwords',
            check: lastFive,
        },
    ];

    useEffect(() => {
    }, [password]);

    useEffect(() => {
    }, [isValidLength, hasNumber, hasUpperCase, hasLowerCase, doesMatch]);

    useEffect(() => {
        if (doesMatch) {
            checkPassword(true);
        } else {
            checkPassword(false);
        }
    }, [doesMatch]);

    return (
        <Section title={props.title || 'Password'} hasLayout padding={props.padding || false}>
            <Col md={12}>
                <DoubleColumn>
                    <Stacked>
                        <Input
                            type={newType}
                            label={props.userId ? 'Password' : 'New Password'}
                            name="password"
                            onChange={setNew}
                            show={showPass}
                            showHide={showHideNew}
                            formik
                        />
                        <Input
                            type={confirmType}
                            label="Confirm Password"
                            name="password_confirm"
                            onChange={setConfirm}
                            show={showConfirm}
                            showHide={showHideConfirm}
                            formik
                        />
                    </Stacked>
                    <Stacked>
                        <label className="password-validation title">Password Requirements:</label>
                        <ul className="list-unstyled password-validation">
                            {rules.map((rule, index) => (
                                <li key={index}>
                                    <i className={`password-validation-icon marginR5 fa ${`fa-${rule.check
                                        ? 'check text-success'
                                        : 'times text-danger'}`}`} />
                                    {rule.label}
                                </li>
                            ))}
                        </ul>
                        {props.extraRules && (
                            <>
                                <label className="password-validation title">You cannot use:</label>
                                <ul className="list-unstyled password-validation">
                                    {additionalRules.map((rule, index) => {
                                        return loading ? (
                                            <li key={index}>
                                                <i className="fa fa-spinner fa-spin" />
                                            </li>
                                        ) : (
                                            <li key={index}>
                                                <i className={`password-validation-icon marginR5 fa ${`fa-${rule.check
                                                    ? 'check text-success'
                                                    : 'times text-danger'}`}`} />
                                                {rule.label}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </>
                        )}
                    </Stacked>
                </DoubleColumn>
                {props.secretQuestion ? (
                    <DoubleColumn>
                        <Select
                            formik
                            name="question"
                            label="Secret Question"
                            addBlank
                        >
                            <option value="5">What city did you grow up in?</option>
                            <option value="4">What highschool did you attend?</option>
                            <option value="2">What is your favorite film?</option>
                            <option value="3">What is your favorite food?</option>
                            <option value="6">What is your first pets name?</option>
                            <option value="1">Who is your role model?</option>
                        </Select>
                        <Input formik name="answer" label="Secret Answer" />
                    </DoubleColumn>
                ) : null}
                {props.heard ? (
                    <Select
                        formik
                        name="heard"
                        label="How did you hear about us? (optional)"
                        addBlank
                    >
                        {props.heard
                            .filter(item => item.active)
                            .map((item, index) => (
                                <option key={index} value={item.heard_id}>{item.heard_name}</option>
                            ))}
                    </Select>
                ) : null}
            </Col>
        </Section>
    );
};

export default Password;